import { ModelBase } from 'store/model-base';

export class CmsBillingExchangeInstruction extends ModelBase {
    public static storeName: string = 'cmsBillingExchangeInstruction';

    public breadcrumbHeading: string;
    public summary: {
        image: CmsMediaImage;
        title: string;
        description: string;
    };
    public sectionOne: CmsBillingExchangeInstructionSection;
    public sectionTwo: CmsBillingExchangeInstructionSection;
    public sectionThree: CmsBillingExchangeInstructionSection;
}
